import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';

import clsx from 'clsx';

import { ChildrenPropType } from 'libs/proptypes';

import { getActivePage } from './PageSideNavigation.utils';
import { PagePropType } from '../../types';

import './PageSideNavigation.scss';

const propTypes = {
  className: PropTypes.string,
  pages: PropTypes.arrayOf(PagePropType).isRequired,
  displayComponent: PropTypes.func.isRequired,
  renderTitle: ChildrenPropType,
};

const defaultProps = {
  className: '',
  renderTitle: ({ title }) => {
    return <>{title}</>;
  },
};

export default function PageSideNavigation({ pages, displayComponent, renderTitle, className }) {
  const [activePage, setActivePage] = useState(getActivePage(pages, null));

  useEffect(() => {
    setActivePage(getActivePage(pages, activePage));
  }, [pages]);

  function handlePageChange(pageIndex) {
    const page = pages[pageIndex];
    setActivePage(page);
  }

  return (
    <div className={clsx('page-side-navigation', className)}>
      <div className="navigation">
        <Menu pointing secondary vertical>
          {pages.map(({ id, title }, index) => (
            <Menu.Item
              key={title}
              active={title === activePage.title}
              onClick={() => handlePageChange(index)}
            >
              {renderTitle({ id, title })}
            </Menu.Item>
          ))}
        </Menu>
      </div>
      <div className="content">{displayComponent({ page: activePage })}</div>
    </div>
  );
}

PageSideNavigation.propTypes = propTypes;
PageSideNavigation.defaultProps = defaultProps;
